import StarIcon from "../../../images/icons/starIcon";
import ImageComponent from "../shared/ImageComponent";
import noProfile from "../../../images/profileImage.png";
import {userRoleList} from "../../../utils/constants";
import {buildImageUrl} from "../../../utils/imageUrlBuilder";
import {interventionDate} from "../../../utils/date";
import {useNavigate} from "react-router-dom";
import {getLatestConversationActivity} from "../../../utils/chatPreview";

const ConversationTab = ({
  closeSideBar,
  conversation,
  selectedConversation,
  onSelectConversation,
  role,
}) => {
  const navigate = useNavigate();
  const endUser =
    role === userRoleList.TECHNICIAN
      ? conversation?.Client?.User
      : conversation?.Technician?.User;
  if (!endUser) return null;
  const activity = getLatestConversationActivity(conversation);

  return (
    <li
      key={conversation.id}
      className={`w-full !pl-3 !pr-1 2xl:!pl-6 2xl:!pr-2 !py-4 flex items-start cursor-pointer border-b border-solid border-[#E0E3F2]  ${
        selectedConversation?.id === conversation.id ? "bg-white" : ""
      }`}
      onClick={() => {
        onSelectConversation(conversation);
        closeSideBar();
        navigate(`#${conversation.id}`);
      }}
    >
      <div className="flex items-center justify-start gap-2 flex-grow max-w-[300px] truncate">
        <div className="relative min-w-10">
          {!!endUser?.avgRating && (
            <div className="bg-[#FFC107] w-[30px] flex justify-center gap-[2px] items-center leading-none p-[1px] text-white text-[7px] absolute bottom-0 rounded-md left-[50%] -translate-x-[50%] ">
              {!!endUser?.avgRating
                ? Number(endUser.avgRating).toFixed(2)
                : "--"}
              <StarIcon className="fill-white stroke-none w-2 h-2" />
            </div>
          )}
          <ImageComponent
            src={buildImageUrl(endUser?.imageUri)}
            alt=""
            className=" w-10 h-10 rounded-full object-cover"
            fallback={
              <img
                src={noProfile}
                alt=""
                className=" w-10 h-10 rounded-full object-cover"
                width="130"
              />
            }
          />
        </div>
        <div className="flex flex-col justify-center items-start flex-grow  ">
          <div className=" text-left font-bold text-[#19295C] capitalize">
            {`${endUser?.lastName} ${endUser?.firstName}`}
          </div>
          <div className="text-left text-sm text-[#7e7e7e] truncate max-w-[220px]" title={activity.preview}>
            {activity.preview}
          </div>
        </div>
      </div>
      <div className="flex flex-col items-end justify-start gap-2 w-fit">
        <span className="text-[10px] w-fit text-nowrap text-[#7e7e7e]">
          {interventionDate(activity.createdAt)}
        </span>
        {conversation?.unreadCount > 0 && (
          <span
            className="min-w-5 h-5 px-1 rounded-full bg-[#FF6600] text-white text-[11px] font-semibold flex items-center justify-center"
            aria-label={`${conversation.unreadCount} messages non lus`}
          >
            {conversation.unreadCount}
          </span>
        )}
      </div>
    </li>
  );
};

export default ConversationTab;
